import React from 'react'
import Moduleslist from '../../component/Administration/adminUser/ModulesList'
export default function ModulesList() {
    return (
        <React.Fragment>
            <Moduleslist />
        </React.Fragment>
    )
}
